import React from 'react';
import { useFormContext } from 'react-hook-form';

interface HiddenInputProps {
  htmlfor: string;
}

const HiddenInput: React.FC<HiddenInputProps> = ({ htmlfor }) => {
  const { register } = useFormContext();
    
  return (
    <input type="hidden" {...register(htmlfor)}/>
  );
};

export default HiddenInput;


